import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorsGenericService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(
        (error: HttpErrorResponse) => {
          switch (error.status) {
            case 200:
              return throwError(error);
            case 400:
              return throwError(error);
            case 401:
              return next.handle(req);
            case 404:
              return throwError(error);
            case 500:
              return throwError(error);
            case 499:
              return throwError(error);
            default:
              return throwError(error);
          }
        }
      )
    );
  }
}
